import { Link } from "react-router-dom";
import { useQuery } from "react-query";
import apiService from "services/api";
import { CustomTable } from "components";
import { actions, columns } from "./constants";

const StaffPage = () => {
	const { data, isLoading } = useQuery("staff", () => apiService.staff.get(undefined, { show_deactivated: true }));

	return (
		<div className="content">
			<div className="mt-3">
				<div className="d-flex mb-2">
					<Link to={`/staff/new`}>
						<button type="button" className="btn btn-info">
							Add new staff
						</button>
					</Link>
				</div>

				<CustomTable data={data} columns={columns} defaultPageSize={25} title="Staffs" actions={actions} loading={isLoading} />
			</div>
		</div>
	);
};

export default StaffPage;
